import { IUnfinishedAuditState } from "src/app/audits/interfaces/unfinished-audit-state.interface";
import { IBulkAddState } from "src/app/inventory/interfaces/bulk-add-state.interface";

export class SaveBulkAddInventorySnapshot {
    static readonly type = '[Application] Save Bulk AddInventory Snapshot';
    constructor(public state: IBulkAddState) {
    }
}

export class GetBulkAddInventorySnapshot {
    static readonly type = '[Application] Get Bulk Add Inventory Snapshot';
    constructor() {
    }
}

export class SaveUnfinishedAuditState {
    static readonly type = '[Application] Save Unfinished Audit State';
    constructor(public state: IUnfinishedAuditState) {
    }
}

export class GetUnfinishedAuditState {
    static readonly type = '[Application] Ge tUnfinished Audit State';
    constructor(public id: string) {
    }
}
